import React, { useState, useEffect } from 'react';

const MAX_EXCEPCIONES_POR_DIA = 3;

const rangosSeSolapan = (aInicio, aFin, bInicio, bFin) => {
  const toMin = (h) => { const [hh, mm] = h.split(':').map(Number); return hh * 60 + mm; };
  return toMin(aInicio) < toMin(bFin) && toMin(bInicio) < toMin(aFin);
};

const ModalEditarExcepcion = ({
  show,
  excepcion,
  excepcionesDelDia = [],
  onSubmit,
  onClose,
  loading = false,
  validarHoras
}) => {
  const esNuevo = !excepcion?.id;

  const [formData, setFormData] = useState({
    tipo: 'cerrado',
    hora_inicio: '09:00',
    hora_fin: '18:00',
    motivo: ''
  });
  const [bloques, setBloques] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    if (excepcion) {
      setFormData({
        tipo: excepcion.tipo || 'cerrado',
        hora_inicio: excepcion.hora_inicio || '09:00',
        hora_fin: excepcion.hora_fin || '18:00',
        motivo: excepcion.motivo || ''
      });
      setBloques([]);
      setError('');
    }
  }, [excepcion, show]);

  const totalExistentes = excepcionesDelDia.length;
  const hayCerradoExistente = excepcionesDelDia.some(e => e.tipo === 'cerrado') || bloques.some(b => b.tipo === 'cerrado');
  const hayEspecialExistente = excepcionesDelDia.some(e => e.tipo === 'horario_especial') || bloques.some(b => b.tipo === 'horario_especial');

  const handleAgregarBloque = () => {
    setError('');

    if (formData.tipo === 'cerrado') {
      setError('El tipo "Cerrado" no se puede combinar con otras excepciones');
      return;
    }

    if (!validarHoras(formData.hora_inicio, formData.hora_fin)) {
      setError('La hora de inicio debe ser menor a la hora de fin');
      return;
    }

    const totalActual = totalExistentes + bloques.length;
    if (totalActual >= MAX_EXCEPCIONES_POR_DIA) {
      setError(`Máximo ${MAX_EXCEPCIONES_POR_DIA} excepciones por día`);
      return;
    }

    const solapaConExistente = [...excepcionesDelDia, ...bloques]
      .filter(e => e.tipo === 'horario_especial' && e.hora_inicio && e.hora_fin)
      .some(e => rangosSeSolapan(formData.hora_inicio, formData.hora_fin, e.hora_inicio, e.hora_fin));

    if (solapaConExistente) {
      setError('Este horario se solapa con otra excepción ya existente o agregada');
      return;
    }

    setBloques([...bloques, { ...formData }]);
    setFormData({ tipo: 'horario_especial', hora_inicio: '09:00', hora_fin: '18:00', motivo: '' });
  };

  const handleQuitarBloque = (idx) => {
    setBloques(bloques.filter((_, i) => i !== idx));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (bloques.length > 0) {
      onSubmit(bloques);
      return;
    }

    if (formData.tipo === 'horario_especial') {
      if (!validarHoras(formData.hora_inicio, formData.hora_fin)) {
        setError('La hora de inicio debe ser menor a la hora de fin');
        return;
      }
    }

    if (esNuevo && formData.tipo === 'cerrado' && hayEspecialExistente) {
      setError('No puedes agregar "Cerrado" porque ya existen horarios especiales para este día');
      return;
    }

    if (esNuevo && formData.tipo === 'horario_especial' && hayCerradoExistente) {
      setError('No puedes agregar horario especial porque ya existe una excepción "Cerrado" para este día');
      return;
    }

    onSubmit(formData);
  };

  const handleClose = () => {
    setError('');
    setBloques([]);
    onClose();
  };

  if (!show || !excepcion) return null;

  const inputStyle = {
    border: '2px solid rgba(59, 130, 246, 0.3)',
    borderRadius: '8px',
    padding: '0.75rem',
    fontSize: '1rem',
    backgroundColor: '#fafafa',
    width: '100%',
    marginTop: '0.5rem',
    transition: 'all 0.2s'
  };

  const puedeAgregarOtro = esNuevo && formData.tipo === 'horario_especial' &&
    (totalExistentes + bloques.length) < MAX_EXCEPCIONES_POR_DIA;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div
        className="modal"
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: '500px',
          borderRadius: '16px',
          overflow: 'hidden'
        }}
      >
        <div style={{
          background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
          padding: '1.25rem 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
            <span style={{ fontSize: '1.4rem' }}>{esNuevo ? '➕' : '✏️'}</span>
            <h3 style={{ margin: 0, color: 'white', fontSize: '1.1rem', fontWeight: '700' }}>
              {esNuevo ? 'Nueva Excepción' : 'Editar Excepción'}
            </h3>
          </div>
          <button
            onClick={handleClose}
            style={{
              background: 'rgba(255,255,255,0.15)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              width: '28px',
              height: '28px',
              cursor: 'pointer',
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit}>
        <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto', padding: '1.5rem' }}>
          {/* Error message */}
          {error && (
            <div style={{
              padding: '0.75rem',
              backgroundColor: '#fee2e2',
              border: '1px solid #fca5a5',
              borderRadius: '6px',
              color: '#991b1b',
              marginBottom: '1rem',
              fontSize: '0.9rem'
            }}>
              ❌ {error}
            </div>
          )}

          {/* Fecha (read-only) */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>
              📅 Fecha
            </label>
            <input
              type="text"
              value={new Date(excepcion.fecha).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
              style={{ ...inputStyle, backgroundColor: '#f3f4f6', cursor: 'not-allowed' }}
              disabled
            />
          </div>

          {/* Bloques ya agregados (solo en modo creación) */}
          {esNuevo && bloques.length > 0 && (
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ fontWeight: '600', color: '#374151', marginBottom: '0.5rem', display: 'block' }}>
                Horarios especiales agregados ({bloques.length})
              </label>
              {bloques.map((b, idx) => (
                <div key={idx} style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '0.6rem 0.75rem',
                  backgroundColor: '#eff6ff',
                  border: '1px solid #bfdbfe',
                  borderRadius: '8px',
                  marginBottom: '0.5rem',
                  fontSize: '0.85rem'
                }}>
                  <span>⏰ {b.hora_inicio} - {b.hora_fin} {b.motivo && `· ${b.motivo}`}</span>
                  <button
                    type="button"
                    onClick={() => handleQuitarBloque(idx)}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#ef4444',
                      cursor: 'pointer',
                      fontWeight: '700'
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* Tipo */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>
              Tipo
            </label>
            <select
              value={formData.tipo}
              onChange={(e) => setFormData({ ...formData, tipo: e.target.value })}
              style={inputStyle}
              disabled={loading || bloques.length > 0}
            >
              <option value="cerrado">Cerrado</option>
              <option value="horario_especial">Horario Especial</option>
            </select>
          </div>

          {/* Horarios (solo si es horario_especial) */}
          {formData.tipo === 'horario_especial' && (
            <>
              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ fontWeight: '600', color: '#374151' }}>
                  Hora Inicio
                </label>
                <input
                  type="time"
                  value={formData.hora_inicio}
                  onChange={(e) => setFormData({ ...formData, hora_inicio: e.target.value })}
                  style={inputStyle}
                  disabled={loading}
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ fontWeight: '600', color: '#374151' }}>
                  Hora Fin
                </label>
                <input
                  type="time"
                  value={formData.hora_fin}
                  onChange={(e) => setFormData({ ...formData, hora_fin: e.target.value })}
                  style={inputStyle}
                  disabled={loading}
                />
              </div>
            </>
          )}

          {/* Motivo */}
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ fontWeight: '600', color: '#374151' }}>
              Motivo (opcional)
            </label>
            <textarea
              value={formData.motivo}
              onChange={(e) => setFormData({ ...formData, motivo: e.target.value })}
              placeholder="Ej: Cierre por mantenimiento"
              style={{ ...inputStyle, minHeight: '80px', fontFamily: 'inherit' }}
              disabled={loading}
            />
          </div>

          {puedeAgregarOtro && (
            <button
              type="button"
              onClick={handleAgregarBloque}
              className="btn btn-secondary"
              style={{ width: '100%' }}
              disabled={loading}
            >
              + Agregar otro horario especial
            </button>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            onClick={handleClose}
            className="btn btn-secondary"
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Guardando...' : bloques.length > 0
              ? `Guardar ${bloques.length} excepción(es)`
              : (esNuevo ? 'Crear Excepción' : 'Guardar Cambios')}
          </button>
        </div>
        </form>
      </div>
    </div>
  );
};

export default ModalEditarExcepcion;
